import { WithdrawalMethods } from '@libs/types';
import { FiatMethods } from './fiatMethods';

export const OPERATION_TEXTS = {
  [WithdrawalMethods.BOG_CARD]: 'withdraw_card_method',
};

export const DIGITAL_OPERATION = 'digital';
export const MERCHANT_OPERATION = 'merchant';

export type OperationMethods =
  | FiatMethods.CARD
  | FiatMethods.CASH
  | FiatMethods.WIRE;
